// // // import React from "react";
// // // import {
// // //   Card,
// // //   CardContent,
// // //   Typography,
// // //   ExpansionPanel,
// // //   ExpansionPanelSummary,
// // //   ExpansionPanelDetails,
// // //   List,
// // //   ListItem,
// // //   ListItemText,
// // //   Divider
// // // } from "@material-ui/core";
// // // import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// // // import NotificationsIcon from "@material-ui/icons/Notifications";

// // // export default function NotificationCard() {
// // //   // 🔔 MOCK NOTIFICATION DATA (ALL IN ONE FILE)
// // //   const notifications = [
// // //     {
// // //       id: 1,
// // //       title: "New Like",
// // //       description: "Amit liked your post",
// // //       time: "Just now"
// // //     },
// // //     {
// // //       id: 2,
// // //       title: "New Comment",
// // //       description: "Sita commented on your photo",
// // //       time: "2 mins ago"
// // //     },
// // //     {
// // //       id: 3,
// // //       title: "New Follower",
// // //       description: "Ramesh started following you",
// // //       time: "5 mins ago"
// // //     },
// // //     {
// // //       id: 4,
// // //       title: "Mention",
// // //       description: "You were mentioned in a post",
// // //       time: "10 mins ago"
// // //     },
// // //     {
// // //       id: 5,
// // //       title: "Story Reaction",
// // //       description: "Anita reacted to your story ❤️",
// // //       time: "30 mins ago"
// // //     },
// // //     {
// // //       id: 6,
// // //       title: "New Post",
// // //       description: "Hari shared a new post",
// // //       time: "1 hour ago"
// // //     },
// // //     {
// // //       id: 7,
// // //       title: "Reply",
// // //       description: "Bikash replied to your comment",
// // //       time: "2 hours ago"
// // //     },
// // //     {
// // //       id: 8,
// // //       title: "Post Saved",
// // //       description: "Pooja saved your post",
// // //       time: "Yesterday"
// // //     },
// // //     {
// // //       id: 9,
// // //       title: "Post Shared",
// // //       description: "Suman shared your post",
// // //       time: "Yesterday"
// // //     },
// // //     {
// // //       id: 10,
// // //       title: "Profile View",
// // //       description: "Someone viewed your profile",
// // //       time: "2 days ago"
// // //     }
// // //   ];

// // //   const hasNotifications = notifications.length > 0;

// // //   return (
// // //     <Card style={{ maxWidth: 500, margin: "20px auto" }}>
// // //       <ExpansionPanel>
// // //         <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
// // //           <NotificationsIcon
// // //             style={{
// // //               marginRight: 8,
// // //               color: hasNotifications ? "inherit" : "inherit"
// // //             }}
// // //           />
// // //           <Typography variant="h6">
// // //             Notifications {hasNotifications && `(${notifications.length})`}
// // //           </Typography>
// // //         </ExpansionPanelSummary>

// // //         <ExpansionPanelDetails style={{ padding: 0 }}>
// // //           {hasNotifications ? (
// // //             <List
// // //               style={{
// // //                 width: "100%",
// // //                 maxHeight: 320,
// // //                 overflowY: "auto"
// // //               }}
// // //             >
// // //               {notifications.map((item, index) => (
// // //                 <React.Fragment key={item.id}>
// // //                   <ListItem button>
// // //                     <ListItemText
// // //                       primary={item.title}
// // //                       secondary={
// // //                         <>
// // //                           <Typography variant="body2" color="textPrimary">
// // //                             {item.description}
// // //                           </Typography>
// // //                           <Typography
// // //                             variant="caption"
// // //                             color="textSecondary"
// // //                           >
// // //                             {item.time}
// // //                           </Typography>
// // //                         </>
// // //                       }
// // //                     />
// // //                   </ListItem>
// // //                   {index !== notifications.length - 1 && <Divider />}
// // //                 </React.Fragment>
// // //               ))}
// // //             </List>
// // //           ) : (
// // //             <Typography
// // //               variant="body2"
// // //               color="textSecondary"
// // //               style={{ padding: 16 }}
// // //             >
// // //               No notifications
// // //             </Typography>
// // //           )}
// // //         </ExpansionPanelDetails>
// // //       </ExpansionPanel>

// // //     </Card>
// // //   );
// // // }


// // // ***************************************************************************************************************************

// // import React, { useState, useEffect } from "react";
// // import {
// //   Card,
// //   CardContent,
// //   Typography,
// //   ExpansionPanel,
// //   ExpansionPanelSummary,
// //   ExpansionPanelDetails,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   Divider,
// //   CircularProgress
// // } from "@material-ui/core";
// // import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// // import NotificationsIcon from "@material-ui/icons/Notifications";
// // import { makeStyles } from "@material-ui/core/styles";
// // import { httpClient } from "appUtility/Api";

// // const useStyles = makeStyles((theme) => ({
// //   notificationItem: {
// //     backgroundColor: "#f5f5f5",
// //     margin: "2px 0",
// //     borderRadius: "4px",
// //     "&:hover": {
// //       backgroundColor: "#e8e8e8",
// //     },
// //   },
// //   listItemText: {
// //     display: "flex",
// //     flexDirection: "column",
// //   },
// //   singleLine: {
// //     display: "flex",
// //     justifyContent: "space-between",
// //     alignItems: "center",
// //     width: "100%",
// //   },
// //   notificationText: {
// //     display: "flex",
// //     flexDirection: "column",
// //     flex: 1,
// //   },
// //   title: {
// //     fontWeight: 500,
// //     marginRight: theme.spacing(2),
// //   },
// //   description: {
// //     color: theme.palette.text.secondary,
// //     fontSize: "0.875rem",
// //   },
// //   time: {
// //     fontSize: "0.75rem",
// //     color: theme.palette.text.secondary,
// //     whiteSpace: "nowrap",
// //     minWidth: "80px",
// //     textAlign: "right",
// //   },
// //   notificationCount: {
// //     backgroundColor: theme.palette.primary.main,
// //     color: "white",
// //     borderRadius: "50%",
// //     width: "24px",
// //     height: "24px",
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "center",
// //     fontSize: "0.75rem",
// //     marginLeft: theme.spacing(1),
// //   },
// // }));

// // export default function NotificationCard(props) {
// //   const classes = useStyles();
// //   const [notifications, setNotifications] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   // Get login details from localStorage
// //   const loginOBJ = localStorage.getItem("login");
// //   let logindetail = {};
  
// //   try {
// //     if (loginOBJ) {
// //       logindetail = JSON.parse(loginOBJ);
// //     }
// //   } catch (e) {
// //     console.error("Error parsing login data:", e);
// //   }

// //   useEffect(() => {
// //     if (props.postID && props.memberID && props.appID && props.companyID) {
// //       fetchNotifications();
// //     }
// //   }, [props.postID, props.memberID, props.appID, props.companyID]);

// //   const fetchNotifications = async () => {
// //     try {
// //       setLoading(true);
      
// //       // Use the props passed from GroupDetail
// //       let appID = props.appID;
// //       let companyID = props.companyID;
// //       let memberID = props.memberID;
// //       let postID = props.postID;
      
// //       // Create FormData with organized payload using props
// //       const formData = new FormData();
// //       formData.append("action", "retrieve");
// //       formData.append("source[appID]", appID);
// //       // formData.append("source[postID]", postID);
// //       formData.append("source[memberID]", memberID);
// //       formData.append("source[companyID]", companyID);
      
// //       // Add groupID if passed as prop
// //       if (props.groupID) {
// //         formData.append("source[groupID]", props.groupID);
// //       }
      
// //       // Use httpClient.post with FormData
// //       httpClient
// //         .post(
// //           "api/social/forum_notifications.php",
// //           formData
// //         )
// //         .then(
// //           ({ data }) => {
// //             if (data && data.success) {
// //               const formattedNotifications = data.data.map(item => {
// //                 return {
// //                   id: item.ID,
// //                   title: item.title,
// //                   description: item.description,
// //                   time: formatTimeAgo(item.created_at),
// //                   created_at: item.created_at
// //                 };
// //               });
// //               setNotifications(formattedNotifications);
// //               setError(null);
// //             } else {
// //               setError("Failed to fetch notifications");
// //             }
// //             setLoading(false);
// //           },
// //           // error handler
// //           (error) => {
// //             setError("Error fetching notifications");
// //             setLoading(false);
// //             console.error("Error fetching notifications:", error);
// //           }
// //         );
      
// //     } catch (err) {
// //       setError("Error fetching notifications");
// //       setLoading(false);
// //       console.error("Error fetching notifications:", err);
// //     }
// //   };

// //   // Function to format timestamp to "time ago" format
// //   const formatTimeAgo = (timestamp) => {
// //     if (!timestamp) return "Recently";
    
// //     const now = new Date();
// //     const past = new Date(timestamp);
    
// //     // Check if date is valid
// //     if (isNaN(past.getTime())) return "Recently";
    
// //     const diffInSeconds = Math.floor((now - past) / 1000);

// //     if (diffInSeconds < 60) return "Just now";
// //     if (diffInSeconds < 3600) return Math.floor(diffInSeconds / 60) + " mins ago";
// //     if (diffInSeconds < 86400) return Math.floor(diffInSeconds / 3600) + " hours ago";
// //     if (diffInSeconds < 604800) return Math.floor(diffInSeconds / 86400) + " days ago";
    
// //     return past.toLocaleDateString();
// //   };

// //   const hasNotifications = notifications.length > 0;

// //   return (
// //     <Card style={{ maxWidth: 500, margin: "20px auto" }}>
// //       <ExpansionPanel>
// //         <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
// //           <NotificationsIcon
// //             style={{
// //               marginRight: 8,
// //               color: hasNotifications ? "primary" : "inherit"
// //             }}
// //           />
// //           <Typography variant="h6" style={{ display: "flex", alignItems: "center" }}>
// //             Notifications
// //             {hasNotifications && (
// //               <span className={classes.notificationCount}>
// //                 {notifications.length}
// //               </span>
// //             )}
// //           </Typography>
// //         </ExpansionPanelSummary>

// //         <ExpansionPanelDetails style={{ padding: 0 }}>
// //           {loading ? (
// //             <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
// //               <CircularProgress size={24} />
// //               <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
// //                 Loading notifications...
// //               </Typography>
// //             </div>
// //           ) : error ? (
// //             <Typography
// //               variant="body2"
// //               color="error"
// //               style={{ padding: 16 }}
// //             >
// //               {error}
// //             </Typography>
// //           ) : hasNotifications ? (
// //             <List
// //               style={{
// //                 width: "100%",
// //                 maxHeight: 320,
// //                 overflowY: "auto"
// //               }}
// //             >
// //               {notifications.map((item, index) => (
// //                 <React.Fragment key={item.id}>
// //                   <ListItem button className={classes.notificationItem}>
// //                     <ListItemText
// //                       disableTypography
// //                       primary={
// //                         <div className={classes.singleLine}>
// //                           <div className={classes.notificationText}>
// //                             <Typography variant="body2" className={classes.title}>
// //                               {item.title}
// //                             </Typography>
// //                             <Typography variant="body2" className={classes.description}>
// //                               {item.description}
// //                             </Typography>
// //                           </div>
// //                           <Typography variant="caption" className={classes.time}>
// //                             {item.time}
// //                           </Typography>
// //                         </div>
// //                       }
// //                     />
// //                   </ListItem>
// //                   {index !== notifications.length - 1 && <Divider />}
// //                 </React.Fragment>
// //               ))}
// //             </List>
// //           ) : (
// //             <Typography
// //               variant="body2"
// //               color="textSecondary"
// //               style={{ padding: 16 }}
// //             >
// //               No notifications
// //             </Typography>
// //           )}
// //         </ExpansionPanelDetails>
// //       </ExpansionPanel>
// //     </Card>
// //   );
// // }

// // *******************************************************************************************************************

// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   ExpansionPanel,
//   ExpansionPanelSummary,
//   ExpansionPanelDetails,
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Button
// } from "@material-ui/core";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import NotificationsIcon from "@material-ui/icons/Notifications";
// import CloseIcon from "@material-ui/icons/Close";
// import { makeStyles } from "@material-ui/core/styles";
// import { httpClient } from "appUtility/Api";
// import PostItem from "../../../../../components/wall/PostList/PostItem";
// import qs from "qs";

// const useStyles = makeStyles((theme) => ({
//   notificationItem: {
//     backgroundColor: "#f5f5f5",
//     margin: "2px 0",
//     borderRadius: "4px",
//     "&:hover": {
//       backgroundColor: "#e8e8e8",
//       cursor: "pointer",
//     },
//   },
//   listItemText: {
//     display: "flex",
//     flexDirection: "column",
//   },
//   singleLine: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     width: "100%",
//   },
//   notificationText: {
//     display: "flex",
//     flexDirection: "column",
//     flex: 1,
//   },
//   title: {
//     fontWeight: 500,
//     marginRight: theme.spacing(2),
//   },
//   description: {
//     color: theme.palette.text.secondary,
//     fontSize: "0.875rem",
//   },
//   time: {
//     fontSize: "0.75rem",
//     color: theme.palette.text.secondary,
//     whiteSpace: "nowrap",
//     minWidth: "80px",
//     textAlign: "right",
//   },
//   notificationCount: {
//     backgroundColor: theme.palette.primary.main,
//     color: "white",
//     borderRadius: "50%",
//     width: "24px",
//     height: "24px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "0.75rem",
//     marginLeft: theme.spacing(1),
//   },
//   dialogTitle: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     padding: theme.spacing(2),
//     borderBottom: `1px solid ${theme.palette.divider}`,
//   },
//   dialogContent: {
//     padding: theme.spacing(2),
//   },
// }));

// export default function NotificationCard(props) {
//   const classes = useStyles();
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedNotification, setSelectedNotification] = useState(null);
//   const [postDialogOpen, setPostDialogOpen] = useState(false);
//   const [postData, setPostData] = useState(null);
//   const [postLoading, setPostLoading] = useState(false);

//   // Get login details from localStorage
//   const loginOBJ = localStorage.getItem("login");
//   let logindetail = {};
  
//   try {
//     if (loginOBJ) {
//       logindetail = JSON.parse(loginOBJ);
//     }
//   } catch (e) {
//     console.error("Error parsing login data:", e);
//   }

//   useEffect(() => {
//     if (props.postID && props.memberID && props.appID && props.companyID) {
//       fetchNotifications();
//     }
//   }, [props.postID, props.memberID, props.appID, props.companyID]);

//   const fetchNotifications = async () => {
//     try {
//       setLoading(true);
      
//       // Use the props passed from GroupDetail
//       let appID = props.appID;
//       let companyID = props.companyID;
//       let memberID = props.memberID;
//       let postID = props.postID;
      
//       // Create FormData with organized payload using props
//       const formData = new FormData();
//       formData.append("action", "retrieve");
//       formData.append("source[appID]", appID);
//       // formData.append("source[postID]", postID);
//       formData.append("source[memberID]", memberID);
//       formData.append("source[companyID]", companyID);
      
//       // Add groupID if passed as prop
//       if (props.groupID) {
//         formData.append("source[groupID]", props.groupID);
//       }
      
//       // Use httpClient.post with FormData
//       httpClient
//         .post(
//           "api/social/forum_notifications.php",
//           formData
//         )
//         .then(
//           ({ data }) => {
//             if (data && data.success) {
//               const formattedNotifications = data.data.map(item => {
//                 return {
//                   id: item.ID,
//                   title: item.title,
//                   description: item.description,
//                   time: formatTimeAgo(item.created_at),
//                   created_at: item.created_at,
//                   // Store the postID from notification for fetching later
//                   notificationPostID: item.postID || item.ID, // Adjust based on your API response
//                 };
//               });
//               setNotifications(formattedNotifications);
//               setError(null);
//             } else {
//               setError("Failed to fetch notifications");
//             }
//             setLoading(false);
//           },
//           // error handler
//           (error) => {
//             setError("Error fetching notifications");
//             setLoading(false);
//             console.error("Error fetching notifications:", error);
//           }
//         );
      
//     } catch (err) {
//       setError("Error fetching notifications");
//       setLoading(false);
//       console.error("Error fetching notifications:", err);
//     }
//   };

//   // Function to format timestamp to "time ago" format
//   const formatTimeAgo = (timestamp) => {
//     if (!timestamp) return "Recently";
    
//     const now = new Date();
//     const past = new Date(timestamp);
    
//     // Check if date is valid
//     if (isNaN(past.getTime())) return "Recently";
    
//     const diffInSeconds = Math.floor((now - past) / 1000);

//     if (diffInSeconds < 60) return "Just now";
//     if (diffInSeconds < 3600) return Math.floor(diffInSeconds / 60) + " mins ago";
//     if (diffInSeconds < 86400) return Math.floor(diffInSeconds / 3600) + " hours ago";
//     if (diffInSeconds < 604800) return Math.floor(diffInSeconds / 86400) + " days ago";
    
//     return past.toLocaleDateString();
//   };

//   const handleNotificationClick = (notification) => {
//     setSelectedNotification(notification);
//     fetchPostDetails(notification.notificationPostID);
//   };

//   const fetchPostDetails = (postID) => {
//     setPostLoading(true);
//     setPostDialogOpen(true);
    
//     // Get user details from localStorage
//     const socialData = JSON.parse(window.localStorage.getItem("login"));
    
//     // Create query to fetch specific post - using qs.stringify like in your example
//     const getPostQuery = {
//       userID: socialData && socialData.uid,
//       userCode: socialData && socialData.memtoken,
//       appID: props.appID || 1,
//       companyID: props.companyID,
//       postID: postID,
//       imageWidth: 600,
//       imageHeight: 600,
//     };

//     httpClient
//       .post(
//         "api/social/posts_get.php",
//         qs.stringify({
//           action: "posts_get",
//           source: getPostQuery,
//         })
//       )
//       .then((res) => {
//         if (res.data && res.data.data && res.data.data.length > 0) {
//           setPostData(res.data.data[0]);
//         } else {
//           // If post not found, create a dummy post from notification
//           setPostData({
//             postID: postID,
//             postTitle: selectedNotification.description || selectedNotification.title,
//             postedDate: selectedNotification.created_at,
//             postedUserName: "System",
//             userThumbnail: "",
//             totalLikes: 0,
//             totalComments: 0,
//             isLiked: 0,
//             images: [],
//             groupID: props.groupID || 0,
//             groupName: "",
//           });
//         }
//         setPostLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching post details:", error);
//         setPostLoading(false);
//       });
//   };

//   const handlePostDialogClose = () => {
//     setPostDialogOpen(false);
//     setPostData(null);
//     setSelectedNotification(null);
//   };

//   const handleDeletePost = (postID, groupID) => {
//     console.log("Delete post:", postID, groupID);
//     // Implement delete logic
//     // After deletion, you might want to close the dialog and refresh notifications
//     handlePostDialogClose();
//     fetchNotifications();
//   };

//   const editPost = (postTitle, imageList, postID, groupID) => {
//     console.log("Edit post:", postTitle, postID, groupID);
//     // Implement edit logic
//   };

//   const hasNotifications = notifications.length > 0;

//   return (
//     <>
//       <Card style={{ maxWidth: 500, margin: "20px auto" }}>
//         <ExpansionPanel>
//           <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
//             <NotificationsIcon
//               style={{
//                 marginRight: 8,
//                 color: hasNotifications ? "primary" : "inherit"
//               }}
//             />
//             <Typography variant="h6" style={{ display: "flex", alignItems: "center" }}>
//               Notifications
//               {hasNotifications && (
//                 <span className={classes.notificationCount}>
//                   {notifications.length}
//                 </span>
//               )}
//             </Typography>
//           </ExpansionPanelSummary>

//           <ExpansionPanelDetails style={{ padding: 0 }}>
//             {loading ? (
//               <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
//                 <CircularProgress size={24} />
//                 <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
//                   Loading notifications...
//                 </Typography>
//               </div>
//             ) : error ? (
//               <Typography
//                 variant="body2"
//                 color="error"
//                 style={{ padding: 16 }}
//               >
//                 {error}
//               </Typography>
//             ) : hasNotifications ? (
//               <List
//                 style={{
//                   width: "100%",
//                   maxHeight: 320,
//                   overflowY: "auto"
//                 }}
//               >
//                 {notifications.map((item, index) => (
//                   <React.Fragment key={item.id}>
//                     <ListItem 
//                       button 
//                       className={classes.notificationItem}
//                       onClick={() => handleNotificationClick(item)}
//                     >
//                       <ListItemText
//                         disableTypography
//                         primary={
//                           <div className={classes.singleLine}>
//                             <div className={classes.notificationText}>
//                               <Typography variant="body2" className={classes.title}>
//                                 {item.title}
//                               </Typography>
//                               <Typography variant="body2" className={classes.description}>
//                                 {item.description}
//                               </Typography>
//                             </div>
//                             <Typography variant="caption" className={classes.time}>
//                               {item.time}
//                             </Typography>
//                           </div>
//                         }
//                       />
//                     </ListItem>
//                     {index !== notifications.length - 1 && <Divider />}
//                   </React.Fragment>
//                 ))}
//               </List>
//             ) : (
//               <Typography
//                 variant="body2"
//                 color="textSecondary"
//                 style={{ padding: 16 }}
//               >
//                 No notifications
//               </Typography>
//             )}
//           </ExpansionPanelDetails>
//         </ExpansionPanel>
//       </Card>

//       {/* Post Detail Dialog Modal */}
//       <Dialog 
//         open={postDialogOpen} 
//         onClose={handlePostDialogClose}
//         maxWidth="md"
//         fullWidth
//         scroll="paper"
//       >
//         <DialogTitle disableTypography className={classes.dialogTitle}>
//           <Typography variant="h6">
//             Post Details
//           </Typography>
//           <IconButton onClick={handlePostDialogClose}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent className={classes.dialogContent}>
//           {postLoading ? (
//             <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
//               <CircularProgress size={24} />
//               <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
//                 Loading post...
//               </Typography>
//             </div>
//           ) : postData ? (
//             <PostItem 
//               postData={postData}
//               userProfile={false}
//               DeleteWork={false}
//               index={0}
//               handleDeletePost={handleDeletePost}
//               editPost={editPost}
//               editClose={false}
//             />
//           ) : (
//             <Typography
//               variant="body2"
//               color="textSecondary"
//               style={{ padding: 16, textAlign: "center" }}
//             >
//               Unable to load post details
//             </Typography>
//           )}
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handlePostDialogClose} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }



import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { httpClient } from "appUtility/Api";
import PostItem from "../../../../../components/wall/PostList/PostItem";
import qs from "qs";

const useStyles = makeStyles((theme) => ({
  notificationItem: {
    backgroundColor: "#f5f5f5",
    margin: "2px 0",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#e8e8e8",
      cursor: "pointer",
    },
  },
  notificationContent: {
    display: "flex",
    alignItems: "center", // Changed from "flex-start" to "center"
    width: "100%",
    padding: theme.spacing(1, 0),
    minHeight: "56px", // Minimum height for better alignment
  },
  notificationIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
    minWidth: "24px",
    fontSize: "20px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  notificationTextContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center", // Center content vertically
  },
  descriptionRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center", // Changed from "flex-start" to "center"
    width: "100%",
  },
  descriptionText: {
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
    lineHeight: 1.3,
    flex: 1,
    marginRight: theme.spacing(1),
    display: "flex",
    alignItems: "center", // Center text vertically
  },
  time: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    minWidth: "80px",
    textAlign: "right",
    display: "flex",
    alignItems: "center", // Center time vertically
  },
  notificationCount: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.75rem",
    marginLeft: theme.spacing(1),
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  dialogContent: {
    padding: theme.spacing(2),
  },
  zmdiIcon: {
    fontFamily: "'Material-Design-Iconic-Font' !important",
    speak: "none",
    fontStyle: "normal",
    fontWeight: "normal",
    fontVariant: "normal",
    textTransform: "none",
    lineHeight: 1,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
  },
}));

// Function to get appropriate zmdi icon class based on notification title/type
const getNotificationIconClass = (title) => {
  const lowerTitle = title.toLowerCase();
  
  if (lowerTitle.includes('like') || lowerTitle.includes('liked')) {
    return "zmdi-thumb-up"; // Like icon
  } else if (lowerTitle.includes('comment')) {
    return "zmdi-comment"; // Comment icon
  } else if (lowerTitle.includes('follower') || lowerTitle.includes('following')) {
    return "zmdi-account-add"; // Follower/Following icon
  } else if (lowerTitle.includes('mention')) {
    return "zmdi-accounts-alt"; // Mention icon
  } else if (lowerTitle.includes('reaction') || lowerTitle.includes('reacted')) {
    return "zmdi-favorite"; // Reaction/Heart icon
  } else if (lowerTitle.includes('shared') || lowerTitle.includes('share')) {
    return "zmdi-share"; // Share icon
  } else if (lowerTitle.includes('view') || lowerTitle.includes('viewed')) {
    return "zmdi-eye"; // View icon
  } else if (lowerTitle.includes('saved')) {
    return "zmdi-bookmark"; // Saved/Bookmark icon
  } else if (lowerTitle.includes('post') && lowerTitle.includes('new')) {
    return "zmdi-file-plus"; // New post icon
  } else if (lowerTitle.includes('reply') || lowerTitle.includes('replied')) {
    return "zmdi-mail-reply"; // Reply icon
  }
  
  // Default icon
  return "zmdi-notifications"; // Notification icon
};

// Function to get notification color based on type
const getNotificationColor = (title) => {
  const lowerTitle = title.toLowerCase();
  
  if (lowerTitle.includes('like') || lowerTitle.includes('liked')) {
    return "#3f51b5"; // Blue
  } else if (lowerTitle.includes('comment')) {
    return "#4caf50"; // Green
  } else if (lowerTitle.includes('follower') || lowerTitle.includes('following')) {
    return "#9c27b0"; // Purple
  } else if (lowerTitle.includes('mention')) {
    return "#ff9800"; // Orange
  } else if (lowerTitle.includes('reaction') || lowerTitle.includes('reacted')) {
    return "#f44336"; // Red
  } else if (lowerTitle.includes('shared') || lowerTitle.includes('share')) {
    return "#2196f3"; // Light Blue
  } else if (lowerTitle.includes('view') || lowerTitle.includes('viewed')) {
    return "#607d8b"; // Blue Grey
  } else if (lowerTitle.includes('saved')) {
    return "#795548"; // Brown
  } else if (lowerTitle.includes('post') && lowerTitle.includes('new')) {
    return "#009688"; // Teal
  } else if (lowerTitle.includes('reply') || lowerTitle.includes('replied')) {
    return "#ff5722"; // Deep Orange
  }
  
  // Default color
  return "#757575";
};

export default function NotificationCard(props) {
  const classes = useStyles();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [postDialogOpen, setPostDialogOpen] = useState(false);
  const [postData, setPostData] = useState(null);
  const [postLoading, setPostLoading] = useState(false);

  // Get login details from localStorage
  const loginOBJ = localStorage.getItem("login");
  let logindetail = {};
  
  try {
    if (loginOBJ) {
      logindetail = JSON.parse(loginOBJ);
    }
  } catch (e) {
    console.error("Error parsing login data:", e);
  }

  useEffect(() => {
    if (props.postID && props.memberID && props.appID && props.companyID) {
      fetchNotifications();
    }
  }, [props.postID, props.memberID, props.appID, props.companyID]);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      
      // Use the props passed from GroupDetail
      let appID = props.appID;
      let companyID = props.companyID;
      let memberID = props.memberID;
      let postID = props.postID;
      
      // Create FormData with organized payload using props
      const formData = new FormData();
      formData.append("action", "retrieve");
      formData.append("source[appID]", appID);
      // formData.append("source[postID]", postID);
      formData.append("source[memberID]", memberID);
      formData.append("source[companyID]", companyID);
      
      // Add groupID if passed as prop
      if (props.groupID) {
        formData.append("source[groupID]", props.groupID);
      }
      
      // Use httpClient.post with FormData
      httpClient
        .post(
          "api/social/forum_notifications.php",
          formData
        )
        .then(
          ({ data }) => {
            if (data && data.success) {
              const formattedNotifications = data.data.map(item => {
                return {
                  id: item.ID,
                  title: item.title,
                  description: item.description,
                  time: formatTimeAgo(item.created_at),
                  created_at: item.created_at,
                  // Store the postID from notification for fetching later
                  notificationPostID: item.postID || item.ID, // Adjust based on your API response
                };
              });
              setNotifications(formattedNotifications);
              setError(null);
            } else {
              setError("Failed to fetch notifications");
            }
            setLoading(false);
          },
          // error handler
          (error) => {
            setError("Error fetching notifications");
            setLoading(false);
            console.error("Error fetching notifications:", error);
          }
        );
      
    } catch (err) {
      setError("Error fetching notifications");
      setLoading(false);
      console.error("Error fetching notifications:", err);
    }
  };

  // Function to format timestamp to "time ago" format
  const formatTimeAgo = (timestamp) => {
    if (!timestamp) return "Recently";
    
    const now = new Date();
    const past = new Date(timestamp);
    
    // Check if date is valid
    if (isNaN(past.getTime())) return "Recently";
    
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) return "Just Now";
    if (diffInSeconds < 3600) return Math.floor(diffInSeconds / 60) + " mins ago";
    if (diffInSeconds < 86400) return Math.floor(diffInSeconds / 3600) + " hours ago";
    if (diffInSeconds < 604800) return Math.floor(diffInSeconds / 86400) + " days ago";
    
    return past.toLocaleDateString();
  };

  const handleNotificationClick = (notification) => {
    setSelectedNotification(notification);
    fetchPostDetails(notification.notificationPostID);
  };

  const fetchPostDetails = (postID) => {
    setPostLoading(true);
    setPostDialogOpen(true);
    
    // Get user details from localStorage
    const socialData = JSON.parse(window.localStorage.getItem("login"));
    
    // Create query to fetch specific post - using qs.stringify like in your example
    const getPostQuery = {
      userID: socialData && socialData.uid,
      userCode: socialData && socialData.memtoken,
      appID: props.appID ,
      companyID: props.companyID,
      postID: postID,
      imageWidth: 600,
      imageHeight: 600,
    };

    httpClient
      .post(
        "api/social/posts_get.php",
        qs.stringify({
          action: "posts_get",
          source: getPostQuery,
        })
      )
      .then((res) => {
        if (res.data && res.data.data && res.data.data.length > 0) {
          setPostData(res.data.data[0]);
        } else {
          // If post not found, create a dummy post from notification
          setPostData({
            postID: postID,
            postTitle: selectedNotification.description || selectedNotification.title,
            postedDate: selectedNotification.created_at,
            postedUserName: "System",
            userThumbnail: "",
            totalLikes: 0,
            totalComments: 0,
            isLiked: 0,
            images: [],
            groupID: props.groupID || 0,
            groupName: "",
          });
        }
        setPostLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching post details:", error);
        setPostLoading(false);
      });
  };

  const handlePostDialogClose = () => {
    setPostDialogOpen(false);
    setPostData(null);
    setSelectedNotification(null);
  };

  const handleDeletePost = (postID, groupID) => {
    console.log("Delete post:", postID, groupID);
    // Implement delete logic
    // After deletion, you might want to close the dialog and refresh notifications
    handlePostDialogClose();
    fetchNotifications();
  };

  const editPost = (postTitle, imageList, postID, groupID) => {
    console.log("Edit post:", postTitle, postID, groupID);
    // Implement edit logic
  };

  const hasNotifications = notifications.length > 0;

  return (
    <>
      <Card style={{ maxWidth: 500, margin: "20px auto" }}>
        <ExpansionPanel>
          {/* <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <NotificationsIcon
              style={{
                marginRight: 8,
                color: hasNotifications ? "primary" : "inherit",
                
              }}
            />
            <Typography variant="h6" style={{ display: "flex", alignItems: "center" }}>
              Notifications
              {hasNotifications && (
                <span className={classes.notificationCount}>
                  {notifications.length}
                </span>
              )}
            </Typography>
          </ExpansionPanelSummary> */}

          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', // Ensure vertical alignment
    width: '100%' 
  }}>
    <NotificationsIcon
      style={{
        marginRight: 8,
        color: hasNotifications ? "primary" : "inherit"
      }}
    />
    <Typography variant="h6" style={{ 
      display: 'flex', 
      alignItems: 'center', // Align text vertically
      flex: 1 // Take remaining space
    }}>
      Notifications
      {hasNotifications && (
        <span className={classes.notificationCount}>
          {notifications.length}
        </span>
      )}
    </Typography>
  </div>
</ExpansionPanelSummary>

          <ExpansionPanelDetails style={{ padding: 0 }}>
            {loading ? (
              <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
                <CircularProgress size={24} />
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                  Loading notifications...
                </Typography>
              </div>
            ) : error ? (
              <Typography
                variant="body2"
                color="error"
                style={{ padding: 16 }}
              >
                {error}
              </Typography>
            ) : hasNotifications ? (
              <List
                style={{
                  width: "100%",
                  maxHeight: 320,
                  overflowY: "auto"
                }}
              >
                {notifications.map((item, index) => (
                  <React.Fragment key={item.id}>
                    <ListItem 
                      button 
                      className={classes.notificationItem}
                      onClick={() => handleNotificationClick(item)}
                    >
                      <div className={classes.notificationContent}>
                        <div 
                          className={classes.notificationIcon}
                          style={{ color: getNotificationColor(item.title) }}
                        >
                          <i 
                            className={`zmdi ${getNotificationIconClass(item.title)} ${classes.zmdiIcon}`}
                            style={{ fontSize: "20px" }}
                          />
                        </div>
                        <div className={classes.notificationTextContainer}>
                          <div className={classes.descriptionRow}>
                            <Typography variant="body2" className={classes.descriptionText}>
                              {item.description}
                            </Typography>
                            <Typography variant="caption" className={classes.time}>
                              {item.time}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </ListItem>
                    {index !== notifications.length - 1 && <Divider />}
                  </React.Fragment>
                ))}
              </List>
            ) : (
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ padding: 16 }}
              >
                No notifications
              </Typography>
            )}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Card>

      {/* Post Detail Dialog Modal */}
      <Dialog 
        open={postDialogOpen} 
        onClose={handlePostDialogClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <Typography variant="h6">
            Post Details
          </Typography>
          <IconButton onClick={handlePostDialogClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
          {postLoading ? (
            <div style={{ padding: 16, textAlign: "center", width: "100%" }}>
              <CircularProgress size={24} />
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                Loading post...
              </Typography>
            </div>
          ) : postData ? (
            <PostItem 
              postData={postData}
              userProfile={false}
              DeleteWork={false}
              index={0}
              handleDeletePost={handleDeletePost}
              editPost={editPost}
              editClose={false}
            />
          ) : (
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ padding: 16, textAlign: "center" }}
            >
              This post cannot be found.
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handlePostDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}